import { pickUserIdFromAuthUser, readPersistedSessionIds } from '../../services/kronosPrefs/sessionIds';
import {
    persistFiltersExpandedScope,
    readPersistedFiltersExpandedUi,
} from '../../services/kronosPrefs/filtersExpandedUi';

export const SET_FILTERS_EXPANDED = 'kronos/filtersExpandedUi/SET';

const initialState = readPersistedFiltersExpandedUi();

export default function filtersExpandedUi(state = initialState, action) {
    switch (action.type) {
        case SET_FILTERS_EXPANDED: {
            const { scope, expanded } = action;
            if (scope === 'analyses') {
                return { ...state, analyses: Boolean(expanded) };
            }
            if (scope === 'lists') {
                return { ...state, lists: Boolean(expanded) };
            }
            const key = scope?.startsWith('exploitation.')
                ? scope.slice('exploitation.'.length)
                : null;
            if (!key) {
                return state;
            }
            return {
                ...state,
                exploitation: {
                    ...state.exploitation,
                    [key]: Boolean(expanded),
                },
            };
        }
        default:
            return state;
    }
}

function resolve_prefs_ids(getState) {
    const u = getState().auth?.user;
    const userId = pickUserIdFromAuthUser(u) || readPersistedSessionIds().userId;
    const instanceId = u?.tkt_instance?.id != null ? String(u.tkt_instance.id) : readPersistedSessionIds().instanceId;
    return { userId, instanceId };
}

export function persistFiltersExpandedUiMiddleware({ getState }) {
    return (next) => (action) => {
        const out = next(action);
        if (action.type === SET_FILTERS_EXPANDED) {
            const { userId, instanceId } = resolve_prefs_ids(getState);
            persistFiltersExpandedScope(action.scope, action.expanded, userId, instanceId);
        }
        return out;
    };
}

/** @param {'exploitation.screenings'|'exploitation.tasks'|'exploitation.programmation'|'analyses'|'lists'} scope */
export function updateFiltersExpanded(scope, expanded) {
    return { type: SET_FILTERS_EXPANDED, scope, expanded };
}

export function select_filters_expanded(state, scope) {
    if (scope === 'analyses') {
        return state.filtersExpandedUi?.analyses ?? false;
    }
    if (scope === 'lists') {
        return state.filtersExpandedUi?.lists ?? false;
    }
    const key = scope?.startsWith('exploitation.')
        ? scope.slice('exploitation.'.length)
        : null;
    if (!key) {
        return false;
    }
    return state.filtersExpandedUi?.exploitation?.[key] ?? false;
}
